var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "data-board-table" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.dataList,
            "default-sort": _vm.sortObj,
            "header-cell-style": { background: "#fafafa", color: "#333333" },
            "max-height": _vm.heightStr,
          },
        },
        [
          _vm._l(
            _vm.config,
            function (
              {
                type,
                prop,
                label,
                width,
                slot,
                align,
                fixed,
                sortable,
                fixWidth,
                children,
                prophtml,
              },
              index
            ) {
              return [
                type
                  ? _c("el-table-column", {
                      key: index,
                      attrs: {
                        label: label,
                        type: type,
                        width: width,
                        align: align,
                      },
                    })
                  : slot
                  ? _c("el-table-column", {
                      key: index,
                      attrs: {
                        prop: prop,
                        label: label,
                        "min-width": width,
                        width: fixWidth,
                        fixed: fixed,
                        align: align,
                        sortable: sortable,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                slot === "image"
                                  ? _c("el-image", {
                                      attrs: {
                                        src: _vm.imageArr[scope.$index],
                                        "preview-src-list": _vm.imageArr,
                                      },
                                    })
                                  : _vm._e(),
                                slot === "index"
                                  ? _c("el-input", {
                                      attrs: { placeholder: "请输入内容" },
                                      model: {
                                        value: scope.$index,
                                        callback: function ($$v) {
                                          _vm.$set(scope, "$index", $$v)
                                        },
                                        expression: "scope.$index",
                                      },
                                    })
                                  : _vm._e(),
                                slot === "input"
                                  ? _c("el-input", {
                                      attrs: { placeholder: "请输入内容" },
                                      model: {
                                        value: scope.row.goodsNo,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "goodsNo", $$v)
                                        },
                                        expression: "scope.row.goodsNo",
                                      },
                                    })
                                  : _vm._e(),
                                slot === "html"
                                  ? _c("p", {
                                      domProps: {
                                        innerHTML: _vm._s(scope.row.content),
                                      },
                                    })
                                  : _vm._e(),
                                _vm.typeStr == "operator"
                                  ? _c(
                                      "div",
                                      { staticClass: "operateBtn" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.examine(scope.row)
                                              },
                                            },
                                          },
                                          [_vm._v("查看")]
                                        ),
                                        _c(
                                          "label",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.suspension(scope.row)
                                              },
                                            },
                                          },
                                          [_vm._v("暂停")]
                                        ),
                                        _c(
                                          "label",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onShowDetail(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("下载")]
                                        ),
                                        _c(
                                          "el-dropdown",
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "el-dropdown-link",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-more",
                                                  staticStyle: {
                                                    "font-size": "12px",
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "el-dropdown-menu",
                                              {
                                                attrs: { slot: "dropdown" },
                                                slot: "dropdown",
                                              },
                                              [
                                                _c("el-dropdown-item", [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.changeHistory(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("变更历史")]
                                                  ),
                                                ]),
                                                _c("el-dropdown-item", [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.deleteFlock(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("删除")]
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : children
                  ? _c(
                      "el-table-column",
                      {
                        key: prop,
                        attrs: {
                          prop: prop,
                          label: label,
                          "min-width": width,
                          width: fixWidth,
                          align: align,
                          sortable: sortable,
                        },
                      },
                      _vm._l(children, function (itemchildren, indexchildren) {
                        return _c("el-table-column", {
                          key: indexchildren,
                          attrs: {
                            prop: itemchildren.prop,
                            "min-width": itemchildren.width,
                            width: itemchildren.fixWidth,
                            label: itemchildren.label,
                            "show-overflow-tooltip": "",
                            align: itemchildren.align,
                            sortable: itemchildren.sortable,
                          },
                        })
                      }),
                      1
                    )
                  : _c("el-table-column", {
                      key: prop,
                      attrs: {
                        prop: prop,
                        label: label,
                        "min-width": width,
                        width: fixWidth,
                        align: align,
                        sortable: sortable,
                      },
                    }),
              ]
            }
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }